import React, { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { useApiGet } from '../../../common/services/api';
import heroTransformer from '../../../game/transformers/hero';
import HeroAvatar from '../../components/HeroAvatar';
import theme from '../../../game/styles/theme';
import ClickOutside from '../../../common/utilities/ClickOutside';

const StyledHeroAvatar = styled(HeroAvatar)`
@media (max-width: 1025px) {
  width: 40px;
  height: 40px;
}
`;

const Expanded = styled.div`
  position: absolute;
  top: 100px;
  left: -10px;
  right: -10px;
  padding: 10px;
  max-height: calc(100vh - 120px);
  /* add a hard z-index to prevent it from showing below the user menu on small screens */
  z-index: 1;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background: ${p => p.theme.modal.background};
  border: ${p => p.theme.modal.border};
  box-shadow: ${p => p.theme.modal.shadow};
  border-radius: ${p => p.theme.modal.radius};

  overflow: auto;

  @media (min-width: 768px) {
    flex-direction: row;
    top: 70px;
    left: 15px;
    right: 15px;
    padding: 15px;
    max-height: calc(100vh - 90px);
  }
  @media (min-width: 768px) and (max-width: 1025px) {
    top: 65px;
    max-height: calc(100vh - 85px);
  }
`;

const ImageWrapper = styled.div`
  img {
    display: block;
    width: 100%;
    height: auto;
    margin: 20px auto;
    max-width: 80%;
  }

  h4 {
    text-transform: uppercase;
    margin-bottom: 0;
    text-align: center;
  }

  @media (min-width: 768px) {
    width: 30%;
  }
${p => p.theme.breakpoints.largeHeight} {
    width: 40%;

    img {
      margin: 50px auto;
      max-height: 300px;
      width: auto;
      height: auto;
    }
  }
`;

const Biography = styled.div`
  margin-left: 15px;
  font-size: 18px;

  @media (min-width: 768px) {
    width: 70%;
  }
  ${p => p.theme.breakpoints.largeHeight} {
    width: 60%;
    font-size: 20px;
  }
`;

function HeroHeader() {
  const { response: heroes = [], isLoading, error } = useApiGet({
    url: 'heroes',
    transformer: heroTransformer,
  });
  const [activeHero, setActiveHero] = useState(null);
  const {
    slug, name, bio, description, favorites = {},
  } = activeHero || {};

  return (
    <ThemeProvider theme={theme}>
      <>
        <ClickOutside onClickOutside={() => setActiveHero(null)}>
          <ul className="navbar-nav mr-auto align-items-md-center flex-row justify-content-center">
            {!isLoading
              && !error
              && heroes.map(hero => (
                <li key={hero.slug} className="mr-2">
                  <StyledHeroAvatar
                    className="btn btn-primary"
                    type="button"
                    color={hero.color}
                    slug={hero.slug}
                    active={slug === hero.slug ? 'true' : undefined}
                    onClick={() => setActiveHero(slug === hero.slug ? null : hero)}
                  />
                </li>
              ))}
          </ul>
          {activeHero && (
            <Expanded>
              <ImageWrapper>
                <h4>{name}</h4>
                <img alt={name} src={`${theme.staticDir}assets/game/sprites/heroes/${slug}.png`} />
                <table className="table border-bottom">
                  <tbody>
                    {Object.keys(favorites).map(key => (
                      <tr key={key}>
                        <th className="p-1">{`${key}:`}</th>
                        <td className="p-1">{favorites[key]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </ImageWrapper>
              <Biography>
                <div dangerouslySetInnerHTML={{ __html: bio }} />
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </Biography>
            </Expanded>
          )}
        </ClickOutside>
      </>
    </ThemeProvider>
  );
}

export default HeroHeader;
